<div
  class="pcir"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.--pcir-color]="color || null"
  role="progressbar"
  [attr.aria-label]="label"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="clamped"
>
  <svg class="pcir__svg" [attr.width]="size" [attr.height]="size" viewBox="0 0 36 36" aria-hidden="true">
    <circle class="pcir__track" cx="18" cy="18" r="16" stroke-width="2.5" fill="none"></circle>
    <circle
      class="pcir__bar"
      cx="18"
      cy="18"
      r="16"
      stroke-width="2.5"
      fill="none"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="progressOffset"
    ></circle>
  </svg>
  <!-- The bar exposes the value; the visible number stays out of the live region around it. -->
  <span class="pcir__value" aria-hidden="true">{{ clamped }}%</span>
</div>
